import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import DatePickerField from './date-picker-field';
import './date-field/result';

Component('tr-date-field', {
  extends: [DatePickerField],

  mixins: [eventListenerMixin],

  properties: {
    disabled: {
      type: Boolean,
      default: false,
      observer() {
        this.nativeField.disabled = this.disabled;
      },
    },
  },

  ready() {
    this.helperText = this.querySelector('.mdc-select-helper-text');
    this.list.setAnchor(this.result.querySelector('.mdc-select'));

    this.bindResultEvents();
    this.bindListEvents();
  },

  layout() {
    this.result.layout();
  },

  disconnected() {
    this.stopListening();
  },

  bindResultEvents() {
    this.listenTo(this.result, {
      'tr-date-field-result:blur': this.handleResultBlur.bind(this),
      'tr-date-field-result:escapePress': () => {
        if (this.list.isOpen()) this.list.close();
        this.result.active = false;
      },
    });
  },

  bindListEvents() {
    this.listenTo(this.list, {
      'tr-date-picker-field-list:beforeOpen': () => {
        this.list.setAnchorMargin({ top: -this.helperText.offsetHeight });
      },
      'tr-date-picker-field-list:opened': this.handleListOpened.bind(this),
      'tr-date-picker-field-list:closed': this.handleListClosed.bind(this),
    });
  },

  handleResultBlur(event) {
    const { relatedTarget } = event.detail.originalEvent;
    if (relatedTarget && this.list.elementInContainer(relatedTarget)) return;

    this.list.close();
  },

  handleListOpened() {
    this.handleResultClick = (event) => {
      if (this.list.isOpen()) event.stopPropagation();
    };
    this.result.addEventListener('click', this.handleResultClick);
  },

  handleListClosed() {
    this.result.active = false;
    this.result.removeEventListener('click', this.handleResultClick);
  },
});
